import CryptoJS from "crypto-js";
import { ivs_key , secret_key } from "../config";

export const AesDecrypt = (data) => { 
 
    const key = CryptoJS.enc.Hex.parse(secret_key); // 128-bit key
    const iv = CryptoJS.enc.Hex.parse(ivs_key); // 128-bit IV

    // Decrypt the data using AES-CBC
    const bytes = CryptoJS.AES.decrypt( data , key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
    return decryptedData
}